export const deepBlue50 = "#eaf3ff";
export const deepBlue100 = "#dcefff";
export const deepBlue200 = "#b9dfff";
export const deepBlue300 = "#81ade2";
export const deepBlue400 = "#6299db";
export const deepBlue500 = "#2e77d0";
export const deepBlue600 = "#2467c6";
export const deepBlue700 = "#1b57bc";
export const deepBlue800 = "#1147b3";
export const deepBlue900 = "#0837a9";
export const deepBlue1000 = "#011989";
export const deepBlueA100 = "#a1c0e8";
export const deepBlueA200 = "#87b0e9";
export const deepBlueA400 = "#7092ca";
export const deepBlueA500 = "#0c366c";
export const deepBlueA1000 = "#071e3c";
